export default {
    PtCustomFieldLabelPane: {
        fieldMainType: {
            public: '企業カスタムフィールド',
            self: '個人用カスタムフィールド',
            shared: '共有スペースからのカスタムフィールド',
        },
        filter: {
            searchFieldPlaceholder: 'カスタムフィールドを検索',
            noFilterData: '結果なし',
            noDataToCreate: 'まだカスタムフィールドはありません、<a href="{href}" target="_blank" rel="noopener">カスタムフィールドを追加します</a>',
            noData: 'まだカスタムフィールドはありません',
        },
        render: {
            noData: {
                DATE: 'ご選択ください',
                NUM: '追加',
                LAYER: 'ご選択ください',
                URL: '追加',
                OPTION: 'ご選択ください',
                STRING: '追加',
            },
        },
        editor: {
            placeholder: {
                DATE: '日付を選ぶ',
                NUM: '数値を入力してください',
                LAYER: '既有ノードを選択',
                URL: 'URLアドレスを入力してください',
                OPTION: '既有オプションを選択',
                STRING: 'テキストを入力してください',
            },
            validator: {
                NUM: {
                    VALID: '合法的な数値を入力してください',
                },
            },
            filter: {
                OPTION: {
                    noFilterData: '該当するものがありません',
                    noData: 'このフィールドにはオプションがありません',
                },
                LAYER: {
                    noFilterData: '該当するノードがありません',
                    noData: 'このフィールドにはノードがありません',
                },
            },
        },
        multiLines: {
            more: 'さらに表示',
            less: '隠す',
        },
        pin: {
            pin: '表頭に固定',
            unPin: '固定解除',
        },
        spaceScopeFieldTip: '✏️Index value is limited to current workspace',
        spaceScopeEditTip: '非全体作用カスタムフィールドは、ワークスペース内でのタグ付けのみに対応しています',
        iconCheck: 'AIタグ付与の検証',
        readAsCheck: '修正はAIタグ付与の検証とみなされます',
    },
};
